export function cleanNumber(number: string): number | null {
  const digits = number.replaceAll(/\D/g, "");

  if (digits) {
    return Number(digits);
  }

  return null;
}

export function numberToEuro(number: number): string {
  const formatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  });

  return formatter.format(number);
}

export function numberToPercent(number: number): string {
  const formatter = new Intl.NumberFormat("de-DE", {
    style: "percent",
    minimumFractionDigits: 1,
  });

  return formatter.format(number);
}
